import React, { useState, useEffect } from "react";
import { ECLLoader, ECLSearch } from "../../../";
import {
   updateServerSession,
   endpointRequest,
} from "../../../../utilities/requests";
import * as arrow from "apache-arrow";

export default function ECLSearchBlock(props) {
   // Take the array of block properties, and map them out into one big state so that we may more easily track all available options
   // While they go from active/inactive (are they a filter, or just a dropdown option), as well as when they are focused/unfocused
   // (For styling)
   const [relationMap, setRelationMap] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);

   useEffect(() => {
      let relations = {};
      const rootId = props.headlist.at(-1);
      const sessionId = props.flatDoc[rootId].session;
      endpointRequest(
         props.parentObject,
         props.block.id,
         sessionId,
         "properties",
      )
         .then((properties) => {
            properties.rows.map((s) => {
               endpointRequest(
                  props.parentObject,
                  props.block.id,
                  sessionId,
                  s[0],
               ).then((property) => {
                  switch (property.columns[0].type.typeId) {
                     case arrow.Type.Utf8:
                        relations[s[0]] = {
                           name: s[0],
                           type: "text",
                           selections: property.rows.map((r, rIndex) => {
                              return {
                                 id: `search-option-${rIndex}`,
                                 name: s[0],
                                 searchableString: r[0].toString(),
                                 jsx: r[0].toString().trim(),
                                 selected: r[1],
                              };
                           }),
                           active: s[1],
                        };
                        break;
                     case arrow.Type.Int:
                        relations[s[0]] = {
                           name: s[0],
                           type: "number",
                           min: property.rows[0][0],
                           max: property.rows[0][1],
                           currentMin: property.rows[0][2],
                           currentMax: property.rows[0][3],
                           active: s[1],
                        };
                        break;
                     case arrow.Type.Int8:
                     case arrow.Type.Int16:
                     case arrow.Type.Int32:
                     case arrow.Type.Int64:
                     case arrow.Type.Decimal:
                     case arrow.Type.Float:
                        relations[s[0]] = {
                           name: s[0],
                           type: "number",
                           min: property.rows[0][0],
                           max: property.rows[0][1],
                           currentMin: property.rows[0][2],
                           currentMax: property.rows[0][3],
                           active: s[1],
                        };
                        break;
                     case arrow.Type.Float16:
                     case arrow.Type.Float32:
                     case arrow.Type.Float64:
                     case arrow.Type.Date:
                     case arrow.Type.DateMillisecond:
                     case arrow.Type.Timestamp:
                        relations[s[0]] = {
                           name: s[0],
                           type: "timestamp",
                           min: property.rows[0][0],
                           max: property.rows[0][1],
                           currentMin: property.rows[0][2],
                           currentMax: property.rows[0][3],
                           active: s[1],
                        };
                        break;
                  }
                  setRelationMap({ ...relationMap, ...relations });
                  setLoading(false);
               });
            });
         })
         .catch((error) => {
            console.error(error);
            setError("Error retrieving filters");
         });
   }, []);

   if (loading || error || !relationMap) {
      return <ECLLoader message={error} />;
   }

   return (
      <ECLSearch
         searchables={relationMap}
         setSearchables={setRelationMap}
         label={props.block.data.name}
         updateState={(keyVals) => {
            updateServerSession(props, keyVals);
            //Update current Min/current Max
            if (keyVals[0].value?.filter?.min) {
               setRelationMap({
                  ...relationMap,
                  [keyVals[0].key]: {
                     ...relationMap[keyVals[0].key],
                     currentMin: keyVals[0].value.filter.min,
                     currentMax: keyVals[0].value.filter.max,
                  },
               });
            }

            //Update current Min/current Max for datetimes
            if (keyVals[0].value?.filter?.datetime_min) {
               setRelationMap({
                  ...relationMap,
                  [keyVals[0].key]: {
                     ...relationMap[keyVals[0].key],
                     currentMin: keyVals[0].value.filter.datetime_min,
                     currentMax: keyVals[0].value.filter.datetime_max,
                  },
               });
            }
         }}
      />
   );
}
